import * as React from "react";
import { FieldValueProduct, Product } from "typings/index";
import { DefaultButton } from "office-ui-fabric-react/lib";
import { BaseFieldEditor } from "../helper";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { getProductById, getAllMediaItems } from "~/state/action";

import styled from "styled-components";
import ProductPickerDialog from "./ProductPicker";
import SimpleProduct from "./SimpleProduct";
import { getProducts } from "~/state/products/action";

export interface Props extends BaseFieldEditor
{
    value: FieldValueProduct;
    placeholder?: string;
}


const  ProductList = styled.div`
    grid-template-columns: 150px 150px 150px 150px;
    grid-gap: 28px;
    display: grid;
    clear: both;
    > button{
        height: 150px;
        background: transparent;
        border: dashed 1px;
    }
`;

const ProductItem  = styled.div`
    position: relative;
    overflow: hidden;
    img{
        max-width: 150px;
        max-height: 150px;
    }
    .ms-Button{
        position: absolute;
        top: 0px;
        right: 0px;
        border: 0px;
        min-width: 32px;
        padding: 0px;
        border-radius: 50px;
        background: white;
        font-size: 10px;
        min-height: 0px;
        margin: 3px;
    }
`;
const ProductPicker: React.FunctionComponent<Props & StateProps> = props =>
{
    const [showProductPickerDialog, setShowProductPickerDialog] = React.useState<boolean>(false);
    React.useEffect( () =>
    {
        if (props.value && props.value.value && props.products && props.products.length !== props.value.value.length)
        {
            props.getProducts(props.value.value);
        }
    }, [ props.products, props.value]);
    
    const showDialog = () =>
    {
        setShowProductPickerDialog(true);
    };

    const onSave = (selectedProducts: string[]) =>
    {
        const fieldValue: FieldValueProduct = { ...props.value, value: selectedProducts };
        props.onValueChange(fieldValue);
        setShowProductPickerDialog(false);
       
    };
    const hideDialog = () =>
    {
        setShowProductPickerDialog(false);
    };
    const onRemoveClick = (id: string) => () =>
    {
        if (props.value.value)
        {
            const fieldValue: FieldValueProduct = { ...props.value, value: props.value.value.filter(x => x !== id) };
            props.onValueChange(fieldValue);
        }
        
    };

    const renderProducts = () =>
    {
        return props.products.map((product, index) =>
        {
           return <ProductItem key={index}>
                <DefaultButton onClick={onRemoveClick(product.id)} iconProps={{iconName: "Delete"}}></DefaultButton>
               <SimpleProduct product={product} files={props.files} />
           </ProductItem> ;
        });
    };
    let addProducts: JSX.Element | null = <DefaultButton onClick={showDialog}>Add products</DefaultButton>;
    if (props.products && props.field.max && props.field.max !== 0 && props.field.max <= props.products.length)
    {
        addProducts = null;
    }

    return (
        <ProductList>
            {renderProducts()}
            {addProducts}
            {showProductPickerDialog ? 
            <ProductPickerDialog onSave={onSave} 
                selectedProducts={props.value && props.value.value ? props.value.value : []} hideDialog={hideDialog}></ProductPickerDialog> 
            : null}
        </ProductList>
    );
    
};


const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    const products: Product[] = []; 
    if (ownProps.value && ownProps.value.value)
    {
        ownProps.value.value.forEach(id => 
        {
            const product: any = getProductById(state, id);
            if (product !== undefined)
            {
                products.push(product);

            }
        });
    }
    return {
        files: getAllMediaItems(state),
        products
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    getProducts: (productIds: string[]) => dispatch(getProducts(productIds))
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(ProductPicker);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/productPicker/index.tsx